import {
  START_END_TO_END_SIMULATION
} from '../actionTypes';

export const startEndToEndSimulation = (endToEndChannelIds, { runSeasim = false, runSimulation = false }) => ({
  type: START_END_TO_END_SIMULATION,
  endToEndChannelIds,
  runSeasim,
  runSimulation
})